// Client side of the TEMPORARY admin account switcher. Holds the signed
// return ticket (server-issued, tamper-proof) so the impersonated session can
// switch back. localStorage is fine here: the ticket is short-lived and
// non-critical — worst case the "return" button doesn't show and you log in.
const KEY = "caloly.admin_return";

export function setReturnTicket(ticket: string | null): void {
  try {
    if (ticket) localStorage.setItem(KEY, ticket);
    else localStorage.removeItem(KEY);
  } catch { /* private mode — the feature just won't offer switch-back */ }
}

export function getReturnTicket(): string | null {
  try { return localStorage.getItem(KEY); } catch { return null; }
}
